import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfigService, FiltersArray, SessionService } from "src/app/core";
import { EventContextService } from "../../events";
import {
  SearchItemResult,
  VisionboardAttributesService,
  VisionboardCategoriesService,
  VisionboardItemSearchService,
  VisionboardVersionsService,
  VisionboardWorkspaceItemsStoreService,
} from "../../visionboard";
import { VenueAdminService } from "./venue-admin.service";

@Injectable()
export class VenueAdminInventoryItemSearchService extends VisionboardItemSearchService {
  constructor(
    protected visionboardAttributesService: VisionboardAttributesService,
    protected visionboardVersionsService: VisionboardVersionsService,
    protected visionboardCategoriesService: VisionboardCategoriesService,
    protected visionboardWorkspaceItemsStoreService: VisionboardWorkspaceItemsStoreService,
    protected appConfigService: AppConfigService,
    protected http: HttpClient,
    protected eventContextService: EventContextService,
    protected sessionService: SessionService,
    private _venueAdminService: VenueAdminService,
  ) {
    super(
      visionboardAttributesService,
      visionboardVersionsService,
      visionboardCategoriesService,
      visionboardWorkspaceItemsStoreService,
      appConfigService,
      http,
      eventContextService,
      sessionService,
    );
  }

  protected override getSearchApiUrl(
    subCategoryId: number,
    count: number,
    page: number,
    includeTotalCount: boolean,
    filtersArray: FiltersArray,
  ): string {
    return this.appConfigService.getVenueAdminInventorySearchUrl(
      this._venueAdminService.activeVenue.id,
      subCategoryId,
      count,
      page,
      includeTotalCount,
      filtersArray,
    );
  }

  protected override getVisionboardItems$(
    count: number,
    page: number,
    includeTotalCount: boolean,
    skipVersionCheck?: boolean,
  ): Observable<SearchItemResult> {
    return super.getVisionboardItems$(count, page, includeTotalCount, true);
  }
}
